<div class="card"
     [class.text-bg-danger]="!group.valid"
     [formGroupName]="groupNameNew"
>
  <div class="card-header d-flex justify-content-between align-items-center">
    <h3 class="card-title">{{ title }}</h3>
    <div class="d-flex flex-row gap-2">
      <a *ngIf="group.get('id').value"
         title="Anzeigen"
         [routerLink]="['/schluessel/private-schluessel', group.get('id').value]"
         class="btn btn-outline-secondary"
      >
        <i class="fa fa-eye"></i>
      </a>
      <app-modal-select
        *ngIf="!readOnly"
        controlName="id"
        [groupName]="groupNamePath"
        title="Suchen"
      >
        <app-private-key-list #selectComponent [selectMode]="true"></app-private-key-list>
      </app-modal-select>
      <button *ngIf="!readOnly"
              class="btn btn-outline-secondary"
              (click)="createNewElement()"
              type="button"
              title="Neu"
      >
        <i class="fa fa-plus"></i>
      </button>
      <button class="btn btn-primary" [disabled]="!form.valid" type="submit">Speichern</button>
    </div>
  </div>
  <ng-container class="card-body">
    <ng-container formGroupName="certificate" *ngIf="certificate.get('id').value">
      <app-form-group control="serialNumber" label="Seriennummer (dez/hex)">
        <p class="form-control-plaintext">{{ certificate.get('serialNumber').value }}
          / {{ certificate.get('serialNumberInHex').value }}</p>
      </app-form-group>

      <app-form-group control="subjectX500Principal" label="Antragssteller">
        <p class="form-control-plaintext">{{ certificate.get('subjectX500Principal').value | principalName: true }}</p>
      </app-form-group>

      <app-form-group control="issuerX500Principal" label="Aussteller">
        <p class="form-control-plaintext">{{ certificate.get('issuerX500Principal').value | principalName: true }}</p>
      </app-form-group>
      <app-form-group control="validFrom" label="Gültig von">
        <p class="form-control-plaintext">{{ certificate.get('validFrom').value }}</p>
      </app-form-group>
      <app-form-group control="validTo" label="Gültig bis">
        <p class="form-control-plaintext">{{ certificate.get('validTo').value }}</p>
      </app-form-group>
    </ng-container>
    <span class="help-block" *ngIf="!group.valid">Dieses Feld ist erforderlich.</span>
  </ng-container>
</div>
